export const errors = {
  463: 'El email que ingresó ya está siendo utilizado por otro usuario, por favor ingresa un email diferente',
  default: 'Error desconocido, vuelva a intentar más tarde',
};
